import styles from './index.less';
import { EyeO } from '@react-vant/icons';
import { useRef, useState } from 'react';
import NoData from '@/components/NoData';
import { getWechatNewsList } from '@/service/banner';
import { Helmet, history, useModel } from '@umijs/max';
import { List, PullRefresh, Image } from 'react-vant';
import defaultInfoUrl2 from '@/assets/home/default_info2.png';

const WechatNews = () => {
  const [WechatNewsList, setWechatNewsList] = useState([]);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );
  const pageNum = useRef(1);
  const [finished, setFinished] = useState<boolean>(false);

  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWechatNewsList([]);

    const data = await getWechatNewsList({
      pageNum: pageNum.current,
      pageSize: 10,
      communityId: defaultRoom?.communityId,
      status: '1'
    });
    const listData: any = [...WechatNewsList, ...data.rows];
    if (isRefresh || pageNum.current === 1) {
      setWechatNewsList(data.rows);
    } else {
      setWechatNewsList(listData);
    }

    if (
      data.rows.length === data.total ||
      data.rows.length < 10 ||
      !data.rows.length ||
      data.total === 0
    ) {
      // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1;
      setFinished(false); // 仍有数据可加载，保持为false
    }
  };

  const onRefresh = async () => {
    pageNum.current = 1;
    setFinished(true);
    setWechatNewsList([]);
    onLoadRefresh(true);
  };

  const click = (item: any) => {
    console.log(item);
    history.push(`/newsDatails?sequenceNbr=${item.sequenceNbr}`);
  };

  return (
    <div className={styles['wechatNews']}>
      <Helmet>
        <title>社区资讯</title>
      </Helmet>
      <div>
        <PullRefresh onRefresh={onRefresh}>
          <List
            finished={finished}
            onLoad={onLoadRefresh}
            finishedText={!WechatNewsList ?.length ? '' : '没有更多了'}
          >
            {WechatNewsList?.length !== 0 ? (
              <>
                {WechatNewsList.map((item: any) => (
                  <div
                    onClick={() => click(item)}
                    className={styles['contentBox']}
                    key={item.sequenceNbr}
                  >
                    <div className={styles.title}>{item.title}</div>
                    <div className={styles.content}>
                      <Image
                        fit="cover"
                        width="100%"
                        src={item.image || defaultInfoUrl2}
                        height="115px"
                        alt={item.title}
                      ></Image>
                      <div className={styles.box}>
                        <div className={styles['viewBox']}>
                          <div>{item.publishTime ? item.publishTime : '-'}</div>
                          <div className={styles.boxs}>
                            <EyeO className={styles.icon} />
                            {item.viewCount ? item.viewCount : 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <NoData />
            )}
          </List>
        </PullRefresh>
      </div>
    </div>
  );
};

export default WechatNews;
